module.exports = __webpack_public_path__ + "static/img/LEADWELL.4dc1299f.jpg";